const team = 
[
        {
            "id": 1,
            "alt": "eze",
            "titulo": "Eze",
            "cargo": "Developer Director",
            "dominio":"Founder",
            "gustos":"Hincha de River, futbol, Giants y NYC.",
            "series":"Los Simpsons, Seinfeld, Friends, The Office",
            "peliculas":"Bañeros 2, Zoolander, SuperBad",
            "musica":"GNR, The Beatles, Molotov, Leo Mattioli"
        },{
            "id": 2,
            "alt": "romi",
            "titulo": "Romi",
            "cargo": "CEO",
            "dominio":"Founder",
            "gustos":"La musica, los Puzzles, las Sopas de letras, buscar ofertas",
            "series":"Dr. House, Law & Order",
            "peliculas":"How to lose a guy in 10 days, Nothing Hill, pelis de Tarantino",
            "musica":"Led Zeppelin, The Beatles"
        },{
            "id": 3,
            "alt": "magic",
            "titulo": "Juan",
            "cargo": "Designer Director",
            "dominio":"Founder",
            "gustos":"Hincha de River, Cine, Diseño, tocar el bajo",
            "series":"GOT, Daredevil, The Punisher",
            "peliculas":"Avengers Endgame, 13 horas, Lord of the Rings",
            "musica":"Iron Maiden, Queen, Blind Guardian"
        },{
            "id": 4,
            "alt": "lau",
            "titulo": "Lau",
            "cargo": "CFO",
            "gustos":"Series, Cine, Leer",
            "series":"Vikings, Outlander, This is us",
            "peliculas":"Como si fuera la primera vez, Sexto Sentido, cualquiera de Disney",
            "musica":"Coldplay, No te va a gustar, Miranda"
        },{
            "id": 5,
            "alt": "sebas",
            "titulo": "Seba",
            "cargo": "DEVELOPER",
            "gustos":"Cine, River, Padel",
            "series":"Breaking bad, Game of thrones, Vikings",
            "peliculas":"La momia, Cruzada",
            "musica":"Imagine Dragons"	
        },{
            "id": 6,
            "alt": "juli",
            "titulo": "Juli",
            "cargo": "DESIGNER",
            "gustos":"Arte, Dibujo, Fotografía, Películas, ver a River",
            "series":"Breaking Bad, Peaky Blinders",
            "peliculas":"Forest Gump, Hachiko",
            "musica":"Maroon Five, Keane"
        },{
            "id": 7,
            "alt": "clari",
            "titulo": "Clari",
            "cargo": "DESIGNER",
            "gustos":"Navegar, viajar, cine",
            "series":"Peaky Blinders, Breaking bad, The Handmaid's Tale",
            "peliculas":"Forest Gump, El padrino, Bastardos sin gloria",
            "musica":"Jack johnson, Blur"
        },{
            "id": 8,
            "alt": "karu",
            "titulo": "Karu",
            "cargo": "ADMIN",
            "gustos":"Cocinar, Leer, Sopa de letras",
            "series":"This is Us, Merli, Vis a Vis",
            "peliculas":"Hombre en llamas, El hijo de la novia, Coyote Ugly",
            "musica":"Ed Sheeran y Ale Sanz"
        },{
            "id": 9,
            "alt": "ina",
            "titulo": "Ina",
            "cargo": "DESIGNER",
            "gustos":"Leer (mucho), sacar fotos, ir al cine",
            "series":"Criminal Minds, Sherlock, Peaky Blinders, Bridgerton",
            "peliculas":"How to train your dragon, Harry Potter",
            "musica":"Arctic Monkeys, Sabrina Carpenter, Muse"
        },{
            "id": 10,
            "alt": "rochi",
            "titulo": "Rosario",
            "cargo": "SOCIAL MEDIA",
            "gustos":"Leer, bailar, mirar series",
            "series":"Prison Break, GOT, La Reina del Flow",
            "peliculas":"El Señor de los Anillos, Aladdin Live Action",
            "musica":"Maroon 5, 30 Seconds to Mars, One Republic, John Mayer"
        },{
            "id": 11,
            "alt": "fede",
            "titulo": "FEDE",
            "cargo": "RENDER",
            "gustos":"fútbol música bateria",
            "series":"El Oso, Better call Saúl, Breaking Bad, Peaky Blinders, Got",
            "peliculas":"Marvel superheoroes",
            "musica":"Iron Maiden, Heavy/Hard Rock"
        }
        			 
]
export default team